module.exports = __webpack_public_path__ + "img/tp-scatter.e6144690.png";